import React, { useEffect, useState } from "react";
import { Card, Col, Row, Switch, Form, Spin } from "antd";
import { useHistory } from "react-router-dom";
import RequestHandler from "util/RequestHandler";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 12,
    },
    sm: {
      span: 12,
    },
  },
  wrapperCol: {
    xs: {
      span: 12,
    },
    sm: {
      span: 12,
    },
  },
};

const UserB2BRoles = (props) => {
  const history = useHistory();
  const [roleList, setRoleList] = useState({ data: [], loading: true });
  const [permissions, setPermissions] = useState({
    modules: [],
    isB2BAllPermissions: false,
  });

  useEffect(() => {
    RequestHandler.get("/User/MenuPermissions", {
      userId: props.userId,
    }).then((response) => {
      setPermissions(response);
      RequestHandler.post(
        "/User/GetB2BRoleList",
        {
          tenantUserId: props.tenantUserId,
        },
        false
      ).then((res) => {
        setRoleList({ data: res.data, loading: false });
      });
    });
  }, []);

  function fullPageAuthOnChange(isChecked) {
    RequestHandler.post("/User/AddRoles", {
      UserId: props.userId,
      isActive: isChecked,
      isB2BAll: true,
    }).then((response) => {
      if (response.success) {
        setPermissions({
          ...permissions,
          isB2BAllPermissions: isChecked,
        });
      }
    });
  }

  function roleSwitchOnChange(isChecked, roleId) {
    const switchDataIndex = roleList.data.findIndex(
      (role) => role.id == roleId
    );

    RequestHandler.post("/User/AddRoles", {
      UserId: props.userId,
      RoleId: roleId,
      isActive: isChecked,
    }).then((response) => {
      if (response.success) {
        const { data } = roleList;
        data[switchDataIndex].isActive = isChecked;

        setRoleList({
          ...roleList,
          data,
        });
      }
    });
  }

  const renderRoleSwitches = () => {
    const moduleIds = [
      ...new Set(roleList.data.map((item) => item.moduleId)),
    ].filter((moduleId) => permissions.modules.includes(moduleId));

    const groupByControllerName = (data) => {
      const grouped = data.reduce((acc, item) => {
        if (!acc[item.controllerName]) {
          acc[item.controllerName] = [];
        }
        acc[item.controllerName].push(item);
        return acc;
      }, {});

      return Object.keys(grouped).map(
        (controllerName) => grouped[controllerName][0]
      );
    };

    return (
      <Row justify="center">
        {groupByControllerName(roleList.data).map((item) => {
          const moduleRoles = roleList.data.filter(
            (role) => role.controllerName == item.controllerName
          );

          if (moduleRoles.length > 0) {
            return (
              <Col xs={24} sm={12} md={8} key={item.id}>
                <Card
                  title={moduleRoles[0].pageName}
                  style={{ margin: "10px 0", height: "90%" }}
                  className="gx-card"
                >
                  {moduleRoles.map((role) => (
                    <Form.Item
                      {...formItemLayout}
                      label={role.name}
                      labelAlign="right"
                      key={role.id}
                    >
                      <Switch
                        disabled={permissions.isB2BAllPermissions}
                        onChange={(isChecked) =>
                          roleSwitchOnChange(isChecked, role.id)
                        }
                        checked={role.isActive}
                      />
                    </Form.Item>
                  ))}
                </Card>
              </Col>
            );
          }
        })}
      </Row>
    );
  };

  return (
    <div>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={4}></Col>
      </Row>

      {roleList.loading ? (
        <Row justify="center">
          <Spin style={{ margin: 5 }} />
        </Row>
      ) : (
        <>
          <Row justify="center">
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                {...formItemLayout}
                label={<b style={{ color: "#1890ff" }}>Tüm İşlemler</b>}
                labelAlign="right"
              >
                <Switch
                  checked={permissions.isB2BAllPermissions}
                  onChange={fullPageAuthOnChange}
                />
              </Form.Item>
            </Col>
          </Row>

          {renderRoleSwitches()}
        </>
      )}
    </div>
  );
};

export default UserB2BRoles;
